let modulesMap = null

function getModules() {
  if (!modulesMap) {
    modulesMap = {}
    if (process.env.SERVER) {
      const modules = require.context('./', true, /index\.js$/)

      modules.keys().forEach(name => {
        const moduleName = name.replace(/\.\/(\w+?)\/index.js$/, '$1')
        modulesMap[moduleName] = modules(name)
      })
    } else {
      const modules = require.context('./', true, /importer\.js$/)

      modules.keys().forEach(name => {
        const moduleName = name.replace(/\.\/(\w+?)\/importer.js$/, '$1')
        modulesMap[moduleName] = modules(name)
      })
    }
  }

  return modulesMap
}

export default function getModule(name) {
  if (!name) return null
  if (process.env.NODE_ENV === 'test') {
    // eslint-disable-next-line
    return require(`./${name}/importer.js`)
  }

  return getModules()[name]
}



// WEBPACK FOOTER //
// ./src/modules/modules-map.js